

// REPO PATH:  src/front-end/code/slices/data/chartName.js
//
// MUST match the processor's normalizeChartName (processing/index.js) exactly.
// The processor canonicalizes at ingest, so everything LIVE arrives already
// normalized; the front-end re-applies the same rule to HISTORICAL data
// (rows written to Mongo before normalization existed) so old spellings
// ('temperature', 'Temperature') merge into the same chart on screen instead
// of appearing as ghost duplicates. Idempotent, so double-applying is free.
//
//   underscores -> spaces, whitespace collapsed, Title Case (case-folded)
//   'family_location' -> 'Family Location'

export function normalizeChartName(raw) {
    return String(raw)
        .replace(/_/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase()
        .replace(/(^|\s)\S/g, (ch) => ch.toUpperCase());
}